import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Badge from "components/bootstrap/Badge";
const StyledBadge = styled(Badge)`
  vertical-align: top;
`;
const BetaBadge = () => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(StyledBadge, { bsStyle: "danger" }, t("badges.beta"));
};
export default BetaBadge;
